/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Dialog_Tools_HeadingInputs */



/**
* | output |
* | --- |
* | "Tools provided" |
*
* @param {Integrations_Dialog_Tools_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_dialog_tools_heading = /** @type {((inputs?: Integrations_Dialog_Tools_HeadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Dialog_Tools_HeadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereitgestellte Werkzeuge")
	return /** @type {LocalizedString} */ ("Tools provided")
});